/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as icvBaseS10Rz from './icvBaseS10Rz';

import * as icvI18S10To from './icvI18S10To';
import * as icvI18S10Co from './icvI18S10Co';

export const N = () => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: '団体',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      cz: {
//        fcyName: '山内地区センター',
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI18S10To.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI18S10Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
